
function $761f97bf09d51d3e$var$adjustHeroHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}
window.addEventListener("resize", $761f97bf09d51d3e$var$adjustHeroHeight);
$761f97bf09d51d3e$var$adjustHeroHeight();
// Fix for mobile browser height jump
const $761f97bf09d51d3e$var$resetHeight = ()=>{
    document.body.style.height = window.innerHeight + "px";
};
window.addEventListener("resize", $761f97bf09d51d3e$var$resetHeight);
$761f97bf09d51d3e$var$resetHeight();
window.toggleMenu = function() {
    const links = document.getElementById("nav-links");
    if (window.innerWidth <= 768) links.classList.toggle("active");
};
// T&C button
window.showTC = function() {
    alert("PROTOCOLO UMBRELLA - T&C:\n\n1. Derecho de admisi\xf3n reservado.\n2. Prohibido armas y objetos punzantes.\n3. Tolerancia cero a estupefacientes y mala conducta.\n4. Prohibido el uso de FLASH en la pista.\n5. El acceso despu\xe9s de medianoche depende del aforo.");
};
window.openModal = function() {
    document.getElementById("payment-modal").style.display = "flex";
    document.body.style.overflow = "hidden"; // Prevents background scrolling
};
window.closeModal = function() {
    document.getElementById("payment-modal").style.display = "none";
    document.body.style.overflow = "auto"; // Restores scrolling
};
// Close when clicking the dark background
window.closeModalOutside = function(event) {
    if (event.target.id === "payment-modal") $761f97bf09d51d3e$var$closeModal();
};
// window so HTML can see fuctions OPENMODAL
window.openModal = function() {
    console.log("Opening Modal..."); // Debug check
    const modal = document.getElementById("payment-modal");
    if (modal) {
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
    }
};
window.closeModal = function() {
    const modal = document.getElementById("payment-modal");
    if (modal) {
        modal.style.display = "none";
        document.body.style.overflow = "auto";
    }
};
window.payRedirect = function(method) {
    const binanceID = "391 699 29";
    if (method === "whatsapp") window.location.href = "https://wa.me/584140939343?text=Ticket-Umbrella+via+Pago+Movil";
    if (method === "binance") navigator.clipboard.writeText(binanceID).then(()=>{
        alert("\u2705 ID COPIADO: " + binanceID + "\n\nEl ID de Binance se ha copiado al portapapeles. P\xe9galo en tu App de Binance para pagar.");
        // by click OK, send them to the form to upload the receipt
        window.open("https://forms.gle/PP7FkCUHDsjNrFua6", "_blank");
    }).catch((err)=>{
        // This was the missing part causing your error!
        console.error("Clipboard error:", err);
        alert("Error al copiar. Por favor usa el ID: " + binanceID);
    });
};
/*document.getElementById("buy-tickets").addEventListener("click", () => {
  // Replace with your Stripe Payment Link or Checkout logic
  alert("Redirecting to secure payment gateway...");
  window.location.href = "https://buy.stripe.com/your_link_here";
});*/ // counter to event
const $761f97bf09d51d3e$var$targetDate = new Date("2026-04-16T20:00:00").getTime();
function $761f97bf09d51d3e$var$updateTimer() {
    const now = new Date().getTime();
    const diff = $761f97bf09d51d3e$var$targetDate - now;
    if (diff <= 0) {
        document.getElementById("timer").innerHTML = "<h2>EVENT LIVE</h2>";
        return;
    }
    // modern way to calculate units
    const time = {
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff / 3600000 % 24),
        mins: Math.floor(diff / 1000 / 60 % 60),
        secs: Math.floor(diff / 1000 % 60)
    };
    // Update the UI
    document.getElementById("days").innerText = String(time.days).padStart(2, "0");
    document.getElementById("hours").innerText = String(time.hours).padStart(2, "0");
    document.getElementById("mins").innerText = String(time.mins).padStart(2, "0");
    document.getElementById("secs").innerText = String(time.secs).padStart(2, "0");
}
// Run every second
setInterval($761f97bf09d51d3e$var$updateTimer, 1000);
$761f97bf09d51d3e$var$updateTimer(); // Run once immediately to avoid "00" blink
// MODAL tickets
function $761f97bf09d51d3e$var$openModal() {
    document.getElementById("payment-modal").style.display = "flex";
}
function $761f97bf09d51d3e$var$closeModal() {
    document.getElementById("payment-modal").style.display = "none";
}
/*function payRedirect(method) {
  if (method === "whatsapp")
    window.location.href =
      "https://wa.me/584140939343?text=I+paid+via+Pago+Movil";
  if (method === "binance")
    alert(
      "Envía tu cripto-pago al Binance ID: 391-699-29 y sube el comprobante o referencia al formulario."
    );
}*/ // QR GENERATOR (Call to preview)
function $761f97bf09d51d3e$var$showTicket(name, ref) {
    document.getElementById("ticket-modal").style.display = "flex";
    document.getElementById("qrcode").innerHTML = "";
    new QRCode(document.getElementById("qrcode"), {
        text: `UMBRELLA2026-${ref}`,
        width: 150,
        height: 150
    });
    document.getElementById("t-name").innerText = `NAME: ${name}`;
    document.getElementById("t-ref").innerText = `REF: #${ref}`;
}


//# sourceMappingURL=repo.fb1a57eb.js.map
